module.exports = __webpack_public_path__ + "static/media/discussion-topic-tips-header.7c0000bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/discussion-topic-tips-header.png
// module id = 1911
// module chunks = 0